import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'
import effects from './effects'
import { createSideEffects } from './plugins'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const logger = false // enable logger explicitly if needed for as it hurts performance

const plugins = [createSideEffects(effects)]
debug && logger && plugins.push(createLogger())

const state = {
  jwt: null,
  id: null,
  unit: 'km',
  lang: 'en',
  user: {},
  vehicle: {},
  video: {},
  track: {}
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: debug,
  plugins: plugins
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js